import { render, staticRenderFns } from "./EmailRedirect.vue?vue&type=template&id=fe7b7850"
import script from "./EmailRedirect.vue?vue&type=script&lang=ts"
export * from "./EmailRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports